module.exports = __webpack_public_path__ + "static/img/bofangluxiang.4e2a341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/bofangluxiang.png
// module id = gsBd
// module chunks = 24